export * from './openscape-logged-agents-list.component';
export * from './openscape-logged-agents-list.module';